<template>
  <div class="overflow-y-hidden">
    <iframe frameBorder="0" v-show="!appLoading" @load="iframeLoaded" width="100%" height="100%" style="border: 0" :src="getKBURL()"></iframe>
  </div>
</template>

<script lang="ts">
import { getStage } from "../util";
import {Component, Vue} from "vue-facing-decorator";
@Component({
  components: {}
})
export default class KnowledgeBase extends Vue {
  private appLoading = false;

  private mounted() {
    this.appLoading = true;
  }

  private iframeLoaded() {
    this.appLoading = false;
  }

  private getKBURL() {
    const stage = getStage();
    switch (stage) {
      case 'prod':
        return 'https://bellnewprod.service-now.com/uke_kb';
      default:
        return 'https://bellnewdev.service-now.com/uke_kb';
    }
  }

}
</script>